import { getBackendClient } from "@/lib/backend";

const backend = getBackendClient();

export interface DeletePaymentResult {
  deleted?: boolean;
  success?: boolean;
}

function firstResult(data: unknown): unknown {
  return Array.isArray(data) ? data[0] : data;
}

export async function deleteCustomerPayment(id: string): Promise<DeletePaymentResult> {
  const { data, error } = await backend.data.rpc("xan_delete_customer_payment", {
    p_payment_id: id,
  });

  if (error) {
    throw new Error(error.message);
  }
  if (!firstResult(data)) {
    throw new Error("Customer payment not found.");
  }

  return { deleted: true };
}
